export * from './src/app/services/authentication.service';
export * from './src/app/services/authentication.guard';
export * from './src/app/services/authorization.service';
export * from './src/app/services/authorization.guard';
export * from './src/app/services/identity.service';
export * from './src/app/strategies/authorization-provider';

export { AuthenticationState } from './src/app/services/authentication-state';

export { AuthModule, AUTH_REDUCERS } from './src/app/app.module';
export { AUTH_ROUTES } from './src/app/auth-routing.module';


import { RemoteAuthStrategy } from './src/app/strategies/remote';
import { Local } from './src/app/strategies/local';

// So dependent modules can set strategy with
// authorizationService.strategy = AuthenticationStrategy.LOCAL
export const AuthenticationStrategy = {
  LOCAL: Local,
  REMOTE: RemoteAuthStrategy
}



// WEBPACK FOOTER //
// ./~/@c4/auth/index.ts